import React from "react";
import styles from "./Tab.module.scss";

interface Props {
	formGroup: React.JSX.Element;
	isActive: boolean;
}

function Tab(props: Props) {
	const { formGroup, isActive } = props;

	return <div className={isActive ? `${styles.tabWrapper}` : `${styles.hidden}`}>{formGroup}</div>;
}

export default Tab;
